/*  ========================================================================
    # Scripts - Floating Banner
    ========================================================================  */

const FloatingBanner = {
  cfg: {
    banners: document.querySelectorAll('.s-floating-banner')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.banners.forEach(banner => {
      // Initial delay before activating the banner
      setTimeout(() => banner.setAttribute('data-activated', 'true'), 2000);

      // Handle the close button
      const closeBtn = banner.querySelector('.s-floating-banner__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          banner.setAttribute('data-closed', 'true');
        });
      }

      const scrollObserveId = banner.getAttribute('data-scroll-observe-id');

      if (scrollObserveId) {
        // Get the section to observe based on the data attribute
        const sectionToObserve = document.getElementById(scrollObserveId);
        // Intersection Observer to hide the banner when the section comes into view and show it again when it goes out of view
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              banner.setAttribute('data-scroll-visible', !entry.isIntersecting);
            });
          },
          { threshold: 0.1 }
        );

        if (sectionToObserve) {
          observer.observe(sectionToObserve);
        }
      }
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.banners.length > 0) this.handler();
  }
};

export default FloatingBanner;
